

































import Vue, { PropType } from 'vue';
import SignatureDialog from './SignatureDialog.vue';

export default Vue.extend({
  components: {
    SignatureDialog,
  },
  props: {
    value: {
      type: Array as PropType<string[]>,
      default: () => ['', ''],
    },

    placeholder: {
      type: String,
      default: () => 'Vul hier je naam in',
    },

    allowSignature: {
      type: Boolean,
      default: false,
    },

    /** Passed through to the dialog; see its `upload` prop. */
    upload: {
      type: Function,
      default: null,
    },

    /** Shows the name and drawing without the means to change either. */
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isValid: false,
      dialog: false,
      isSaving: false,
    };
  },

  methods: {
    scrollTo() {
      setTimeout(() => this.$scrollTo((this.$refs.input as Vue).$el, 100, { offset: -150 }), 100);
    },

    save() {
      this.$emit('input', this.value);
    },
  },
});
